<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="result.name"
        label="ID"
        outlined
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LargeTextComponent',
  props: {
    baseValue: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
  },
  data() {
    return {
      result: { ...this.baseValue },
    }
  },
  emits: ['formAddEvent'],
  watch: {
    result: {
      handler() {
        this.sendDataToParent()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = {
        name: this.result.name,
      }
      this.$emit('formAddEvent', dataToSend)
    },
  },
})
</script>
